import { splitTechnicalDetails } from '../shared/error-details';
import './technical-details.css';

/**
 * The exact error, one click away. The plain sentence is always shown first
 * by the caller; this holds what support needs and an operator can ignore.
 */
export function TechnicalDetails({ detail }: { detail?: string | null }) {
  if (!detail) return null;
  return (
    <details className="technical-details">
      <summary>Technical details</summary>
      <code>{detail}</code>
    </details>
  );
}

/** A message that may carry technical details: the sentence, then the disclosure. */
export function OperatorErrorText({ message, className }: { message: string; className?: string }) {
  const split = splitTechnicalDetails(message);
  return (
    <span className={`operator-error-text${className ? ` ${className}` : ''}`}>
      <span>{split.message}</span>
      <TechnicalDetails detail={split.detail} />
    </span>
  );
}
